export default __webpack_public_path__ + "static/media/imgLight5.d81a5a16.png";